// 抑制 ResizeObserver 循环警告（这是浏览器内部机制的警告，不影响功能）
// 这是 Element Plus 组件（如 el-descriptions、el-table）在计算布局时的正常行为
// 必须在所有其他代码之前执行，确保在 webpack-dev-server overlay 显示之前拦截错误

// 直接隐藏 webpack-dev-server 的错误覆盖层（如果存在）
if (typeof window !== 'undefined') {
  // 隐藏错误覆盖层的函数
  const hideOverlay = () => {
    try {
      // 确保 DOM 已加载
      if (!document || !document.body) return
      
      // 查找并隐藏 webpack-dev-server 的错误覆盖层
      const overlay = document.querySelector('#webpack-dev-server-client-overlay')
      if (overlay) {
        overlay.style.display = 'none'
        // 安全地移除元素（检查是否是父节点的子节点）
        try {
          if (overlay.parentNode && overlay.parentNode.contains(overlay)) {
            overlay.parentNode.removeChild(overlay)
          } else {
            // 如果无法通过 parentNode 移除，尝试使用 remove 方法
            overlay.remove()
          }
        } catch (e) {
          // 如果移除失败，只隐藏即可
          overlay.style.display = 'none'
        }
      }
      
      // 也尝试隐藏其他可能的覆盖层元素
      const overlays = document.querySelectorAll('[class*="overlay"], [id*="overlay"]')
      overlays.forEach(el => {
        try {
          const text = (el.textContent || el.innerText || '').toLowerCase()
          if (text.includes('resizeobserver') || text.includes('resizeobserver loop')) {
            el.style.display = 'none'
            // 安全地移除元素
            if (el.parentNode && el.parentNode.contains(el)) {
              try {
                el.parentNode.removeChild(el)
              } catch (e) {
                // 如果移除失败，只隐藏即可
                el.style.display = 'none'
              }
            } else {
              // 如果无法通过 parentNode 移除，尝试使用 remove 方法
              try {
                el.remove()
              } catch (e) {
                // 如果移除失败，只隐藏即可
                el.style.display = 'none'
              }
            }
          }
        } catch (e) {
          // 忽略单个元素的错误
        }
      })
    } catch (e) {
      // 忽略错误
    }
  }
  
  // DOM 加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideOverlay)
  } else {
    hideOverlay()
  }
  
  // 使用 MutationObserver 监听 DOM 变化，自动隐藏新出现的错误覆盖层
  if (document.body || document.documentElement) {
    const observer = new MutationObserver(() => {
      hideOverlay()
    })
    
    // 观察整个文档的变化
    const target = document.body || document.documentElement
    if (target) {
      observer.observe(target, {
        childList: true,
        subtree: true
      })
    }
  }
  
  // 定期检查（作为备用方案）
  setInterval(hideOverlay, 500)
}

const resizeObserverLoopErrRe = /ResizeObserver.*loop/i
const resizeObserverLoopErrRe2 = /ResizeObserver.*completed/i
const resizeObserverLoopErrRe3 = /ResizeObserver.*undelivered/i

// 检查错误消息是否与 ResizeObserver 相关
const isResizeObserverError = (message) => {
  if (!message) return false
  const msg = String(message).toLowerCase()
  return (
    resizeObserverLoopErrRe.test(msg) ||
    resizeObserverLoopErrRe2.test(msg) ||
    resizeObserverLoopErrRe3.test(msg) ||
    msg.includes('resizeobserver')
  )
}

// 检查是否是 DOM 相关的无害错误（路由切换时可能发生）
const isHarmlessDOMError = (message, stack) => {
  if (!message && !stack) return false
  const fullText = (message + ' ' + stack).toLowerCase()
  return (
    fullText.includes('parentnode') ||
    fullText.includes('parent node') ||
    fullText.includes('subtree') ||
    fullText.includes('sub tree') ||
    fullText.includes('cannot read properties of null') ||
    (fullText.includes('reading') && fullText.includes('parentnode'))
  )
}

// 处理同步错误（使用捕获阶段，确保在其他处理器之前处理）
window.addEventListener('error', (e) => {
  // 收集所有可能的错误信息（包括堆栈）
  const errorMessage = (
    e.message || 
    e.error?.message || 
    e.error?.toString() || 
    e.toString() || 
    ''
  )
  const errorStack = (
    e.error?.stack || 
    e.stack || 
    ''
  )
  const fullErrorText = (errorMessage + ' ' + errorStack).toLowerCase()
  
  // 检查是否是 ResizeObserver 错误，或者错误来自 overlay.js 且包含 ResizeObserver
  if (
    isResizeObserverError(errorMessage) || 
    isResizeObserverError(errorStack) ||
    (fullErrorText.includes('overlay.js') && fullErrorText.includes('resizeobserver'))
  ) {
    e.stopImmediatePropagation()
    e.preventDefault()
    e.stopPropagation()
    return false
  }
  
  // 检查是否是路由切换时的无害 DOM 错误
  if (isHarmlessDOMError(errorMessage, errorStack)) {
    e.stopImmediatePropagation()
    e.preventDefault()
    e.stopPropagation()
    return false
  }
}, true)

// 处理未捕获的 Promise 拒绝
window.addEventListener('unhandledrejection', (e) => {
  const errorMessage = e.reason?.message || e.reason?.toString() || String(e.reason || '')
  const errorStack = e.reason?.stack || ''
  const fullErrorText = (errorMessage + ' ' + errorStack).toLowerCase()
  
  if (
    isResizeObserverError(errorMessage) || 
    isResizeObserverError(errorStack) ||
    (fullErrorText.includes('overlay.js') && fullErrorText.includes('resizeobserver'))
  ) {
    e.preventDefault()
    e.stopPropagation()
    return false
  }
  
  // 检查是否是路由切换时的无害 DOM 错误
  if (isHarmlessDOMError(errorMessage, errorStack)) {
    e.preventDefault()
    e.stopPropagation()
    return false
  }
}, true)

// 拦截 console.error 中的 ResizeObserver 警告（webpack-dev-server 的错误覆盖层会显示这些）
const originalConsoleError = console.error
console.error = function(...args) {
  const errorMessage = args.map(arg => 
    typeof arg === 'object' ? (arg?.message || arg?.toString() || JSON.stringify(arg)) : String(arg)
  ).join(' ')
  
  if (isResizeObserverError(errorMessage)) {
    // 静默处理，不输出到控制台
    return
  }
  // 其他错误正常输出
  originalConsoleError.apply(console, args)
}

// 拦截 console.warn 中的 ResizeObserver 警告
const originalConsoleWarn = console.warn
console.warn = function(...args) {
  const errorMessage = args.map(arg => {
    if (arg === null || arg === undefined) {
      return String(arg)
    }
    if (typeof arg === 'object') {
      try {
        return arg?.message || (typeof arg?.toString === 'function' ? arg.toString() : JSON.stringify(arg))
      } catch (e) {
        return String(arg)
      }
    }
    return String(arg)
  }).join(' ')
  
  if (isResizeObserverError(errorMessage)) {
    // 静默处理，不输出到控制台
    return
  }
  // 其他警告正常输出
  originalConsoleWarn.apply(console, args)
}

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router)
// 配置 Element Plus 使用中文
app.use(ElementPlus, {
  locale: zhCn
})

// 全局处理图片预览遮罩层点击关闭功能
let imagePreviewObserver = null
let currentMaskElement = null

const handleImagePreviewMaskClick = (event) => {
  // 检查点击的是遮罩层而不是图片本身
  const target = event.target
  // 如果点击的是遮罩层（.el-image-viewer__mask）而不是画布区域，则关闭预览
  if (target.classList.contains('el-image-viewer__mask')) {
    // 查找关闭按钮并触发点击
    const closeBtn = document.querySelector('.el-image-viewer__close')
    if (closeBtn) {
      closeBtn.click()
    }
  }
}

// 监听图片预览器的出现和消失
imagePreviewObserver = new MutationObserver(() => {
  const mask = document.querySelector('.el-image-viewer__mask')
  if (mask && mask !== currentMaskElement) {
    // 预览器已打开，添加点击事件
    currentMaskElement = mask
    mask.addEventListener('click', handleImagePreviewMaskClick)
    
    // 添加样式提示用户可以点击关闭
    if (!mask.style.cursor) {
      mask.style.cursor = 'pointer'
    }
  } else if (!mask && currentMaskElement) {
    // 预览器已关闭，清理引用
    if (currentMaskElement) {
      currentMaskElement.removeEventListener('click', handleImagePreviewMaskClick)
      currentMaskElement = null
    }
  }
})

// 开始观察 DOM 变化
imagePreviewObserver.observe(document.body, {
  childList: true,
  subtree: true
})

// 添加全局样式，确保遮罩层可以点击
const style = document.createElement('style')
style.textContent = `
  .el-image-viewer__mask {
    cursor: pointer !important;
  }
  .el-image-viewer__canvas {
    cursor: default !important;
    pointer-events: auto !important;
  }
`
document.head.appendChild(style)

app.mount('#app')
